import SourceCodeComponent from "./SourceCodeComponent";
import FunctionAnalysis from "../effects/FunctionAnalysis";
import StepAnalysis from "../effects/StepAnalysis";

export default function DailyCC( { data, blog } ) {
  // if (!data || data.length < 3) {
  //   return <div>Loading...</div>;
  // }

  const video = data[0]?.video?.file?.url || '';
  const sourcecodeData = data[1]?.code;

  const sourcecode = data[1]?.code?.rich_text?.[0]?.plain_text || '';

  const lines = sourcecode.split("\n");

  const summary = blog.properties.Summary?.rich_text?.[0]?.plain_text;
  const link = blog.properties.Link?.rich_text?.[0]?.plain_text;

  //STATS
  const streak = Math.floor((new Date() - new Date("2023-08-01")) / (1000 * 60 * 60 * 24));
  const number = Math.floor((new Date( summary.slice(0, 10) ) - new Date("2023-08-01")) / (1000 * 60 * 60 * 24));

  return (
    <div className = "dailyccComponent">

      <div className = "codestats">
          <video style = { { width : "300px", height : "300px", borderRadius : "4px"} } controls><source src =  { video } type = "video/mp4"/></video>
          
          <div>
            <h3>Code Stats</h3>
            <ul>
                <li>Sketch : { number } / { streak }</li>
                <li>Lines : { lines.length }</li>
                <li><a className = "animated-underline" target="_blank" href = { link }>{ link }</a></li>
            </ul>
          </div>
      </div>

      <br/><br/><br/>

      <div className = "dailyccContents">
        <div className = "dailyccAnalysis">
            <StepAnalysis sourcecode = { sourcecode }/>
            <FunctionAnalysis sourcecode = { sourcecode } />
        </div>

        <div style = { { flex : 2 } }>
          <SourceCodeComponent data = { sourcecodeData }/>
        </div>
      </div>
      
      <br/><br/><br/>
      
    </div>
  );
}